import React from "react";
import styles from "./OfferTableHeader.module.css";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {OfferTableSortingField} from "../../../../../api/generated";
import {SortableHeaderCell, TableSort} from "../../../../elements/sortableHeaderCell/SortableHeaderCell";
import {offerTableRequestSelector, updateOfferTableRequest} from "../../offerListSlice";

export const OfferTableHeader: React.FC = () => {
    const dispatch = useAppDispatch()
    const {sortBy, sortDirection} = useAppSelector(offerTableRequestSelector)
    const sort: TableSort<OfferTableSortingField> = {sortBy, sortDirection}

    const handleSort = (nextSort: TableSort<OfferTableSortingField>) => {
        dispatch(updateOfferTableRequest(nextSort))
    }

    return <div className={styles.wrapper}>
        <SortableHeaderCell className={styles.titleCell} title={"Title & Description"} sortKey={OfferTableSortingField.Title} sort={sort} onSort={handleSort}/>
        <SortableHeaderCell className={styles.typeCell} title={"Type"} sortKey={OfferTableSortingField.Type} sort={sort} onSort={handleSort}/>
        <SortableHeaderCell className={styles.vehicleCell} title={"Vehicle"} sortKey={OfferTableSortingField.Vehicle} sort={sort} onSort={handleSort}/>
        <SortableHeaderCell className={styles.datesCell} title={"Dates"} sortKey={OfferTableSortingField.Dates} sort={sort} onSort={handleSort}/>
        <span className={styles.valueCell}>Value</span>
        <SortableHeaderCell className={styles.sourceCell} title={"Source"} sortKey={OfferTableSortingField.Source} sort={sort} onSort={handleSort}/>
        <span className={styles.actionsCell}>Actions</span>
    </div>
}
